var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPython(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1755441330022,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 15003,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M429.824 128c-60.672 0-109.824 49.152-109.824 109.824v64.512h164.7616c14.9504 0 27.2384 21.9136 27.2384 36.864H237.824c-60.672 0-109.824 49.152-109.824 109.824v145.2032c0 60.672 49.152 109.824 109.824 109.824h45.312v-102.912c0-60.672 48.7936-109.824 109.4656-109.824h201.5744a109.5168 109.5168 0 0 0 109.8752-109.4656V237.824c0-60.672-49.152-109.824-109.8752-109.824h-164.352z m-27.648 61.8496c15.36 0 27.648 4.608 27.648 27.2384 0 22.6816-12.288 34.2016-27.648 34.2016-14.9504 0-27.2384-11.52-27.2384-34.1504 0-22.6816 12.288-27.2896 27.2384-27.2896z",
    "p-id": 15004
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M740.864 320v102.912a109.4656 109.4656 0 0 1-109.4656 109.824H429.824a109.5168 109.5168 0 0 0-109.824 109.4144v144.0256A109.824 109.824 0 0 0 429.824 896h164.352a109.824 109.824 0 0 0 109.824-109.7728v-64.512h-164.7616c-15.0016 0-27.2384-21.9136-27.2384-36.864h274.176a109.824 109.824 0 0 0 109.8752-109.8752V429.824a109.824 109.824 0 0 0-109.8752-109.824h-45.312zM370.688 493.312l-0.1536 0.1536c0.512-0.0512 0.9728 0 1.4848-0.1536H370.688z m251.136 279.3984c15.0016 0 27.2896 11.52 27.2896 34.2016a27.2384 27.2384 0 0 1-27.2896 27.2384c-15.36 0-27.648-4.608-27.648-27.2384 0-22.6816 12.288-34.2016 27.648-34.2016z",
    "p-id": 15005
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/python.6ad4ca89c4f69d73b64bf19203efc1ad.svg";
export { ForwardRef as ReactComponent };